import { render } from "./ToastHost.vue?vue&type=template&id=def3a9e0"
import script from "./ToastHost.vue?vue&type=script&lang=js"
export * from "./ToastHost.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__